'use strict';

var $ = require('jquery');
var _ = require('underscore');
var business = require('./business');

const isTestRunner = Boolean(window.should);
let allFeaturesOn = false;
let featuresForcedOff = [];

/**
 * Remember to keep this in sync with the constants in security_permissions
 */
var permissionConstants = {
    BILLING_PAYMENT_METHOD_EDIT: 'billing_payment_method_edit',

    ONLINEBOOKING_DETAILS_EDIT: 'onlinebooking_details_edit',
    ONLINEBOOKING_DETAILS_VIEW: 'onlinebooking_details_view',
    ONLINEBOOKING_PAYMENTS_LINK: 'onlinebooking_payments_link',
    ONLINEBOOKING_PAYMENT_SETTINGS_EDIT: 'onlinebooking_payment_settings_edit',

    BRANDING_EDIT: 'branding_edit',
    BUSINESS_PERMISSIONS_GRANT: 'business_permissions_grant',
    BUSINESS_DETAILS_VIEW: 'business_details_view',
    BUSINESS_DETAILS_EDIT: 'business_details_edit',
    BUSINESS_LEAVE_EDIT: 'business_leave_edit',
    STAFF_DETAILS_VIEW: 'staff_details_view',
    STAFF_DETAILS_EDIT: 'staff_details_edit',
    STAFF_ROLE_EDIT: 'staff_role_edit',
    STAFF_TIMETABLE_OVERRIDE_EDIT: 'staff_timetable_override_edit',
    STAFF_TIMETABLE_VIEW_OWN: 'staff_timetable_view_own',
    STAFF_TIMETABLE_EDIT: 'staff_timetable_edit',

    APPOINTMENT_DETAILS_EDIT: 'appointment_details_edit',
    APPOINTMENT_DETAILS_VIEW: 'appointment_details_view',
    APPOINTMENT_NOTES_EDIT: 'appointment_notes_edit',
    APPOINTMENT_DEPOSIT_ADHOC_REFUND: 'appointment_deposit_adhoc_refund',

    INVOICE_DETAILS_EDIT: 'invoice_details_edit',
    INVOICE_DETAILS_VIEW: 'invoice_details_view',
    INVOICE_PAYMENT_TYPES_EDIT: 'invoice_payment_types_edit',
    INVOICE_PREPSALE_CREATE: 'invoice_prepsale_create',
    INVOICE_ITEM_ADD_REMOVE: 'invoice_item_add_remove',
    INVOICE_QUANTITY_EDIT: 'invoice_quantity_edit',
    INVOICE_PRICE_EDIT: 'invoice_price_edit',
    INVOICE_VOUCHER_PRICE_EDIT: 'invoice_voucher_price_edit',
    INVOICE_OVERALL_ADVANCED_DISCOUNT_EDIT: 'invoice_overall_advanced_discount_edit',
    INVOICE_ITEM_ADVANCED_DISCOUNT_EDIT: 'invoice_item_advanced_discount_edit',
    INVOICE_OVERALL_MANUAL_DISCOUNT_EDIT: 'invoice_overall_manual_discount_edit',
    INVOICE_ITEM_MANUAL_DISCOUNT_EDIT: 'invoice_item_manual_discount_edit',
    INVOICE_SALESPERSON_EDIT: 'invoice_salesperson_edit',
    INVOICE_CUSTOMER_EDIT: 'invoice_customer_edit',
    INVOICE_NOTES_EDIT: 'invoice_notes_edit',
    INVOICE_PRINT: 'invoice_print', // WARNING, this is not named very well it should probably be called "INVOICE_PRINT_QUOTE", this is actually tied to "Prepare sales" permission group.
    INVOICE_COMMITTED_EDIT: 'invoice_committed_edit',
    INVOICE_COMMITTED_EDIT_ADVANCED: 'invoice_committed_edit_advanced',
    INVOICE_UNCOMMITTED_DELETE: 'invoice_uncommitted_delete',
    INVOICE_COMMITTED_DELETE: 'invoice_committed_delete',
    INVOICE_COMMITTED_DELETE_SAME_DAY_ONLY: 'invoice_committed_delete_same_day_only',
    INVOICE_PAYMENT_ADD: 'invoice_payment_add',
    INVOICE_PAYMENT_REMOVE: 'invoice_payment_remove',
    INVOICE_PAYMENT_EDIT: 'invoice_payment_edit',
    INVOICE_COMMIT: 'invoice_commit',
    INVOICE_ACTIVATION_EDIT: 'invoice_activation_edit',
    INVOICE_BACKDATING: 'invoice_backdating',

    MARKETING_MAILCHIMP_LINK_ACCOUNT: 'marketing_mailchimp_link_account',
    MARKETING_MAILCHIMP_EDIT: 'marketing_mailchimp_edit',
    MARKETING_KMAIL_EDIT: 'marketing_kmail_edit',
    MARKETING_BULK_SMS_CREATE: 'marketing_bulk_sms_create',

    CLIENT_DETAILS_CREATE: 'client_details_create',
    CLIENT_DETAILS_EDIT: 'client_details_edit',
    CLIENT_DETAILS_VIEW: 'client_details_view',
    CLIENT_DETAILS_DELETE: 'client_details_delete',
    CLIENT_HISTORY_VIEW: 'client_history_view',
    CLIENT_CONTACT_DETAILS_VIEW: 'client_contact_details_view',
    CLIENT_CONTACT_DETAILS_EDIT: 'client_contact_details_edit',
    CLIENT_ATTACHMENT_EDIT: 'client_attachment_edit',
    CLIENT_LIST_FILTER: 'client_list_filter',
    CLIENT_LIST_DOWNLOAD: 'client_list_download',
    CLIENT_LIST_SEARCH: 'client_list_search',
    CLIENT_LIST_SEARCH_ACROSS_BRANCH: 'client_list_search_across_branch',
    CLIENT_LIST_IMPORT: 'client_list_import',
    CLIENT_DAY_VIEW: 'client_day_view',
    CLIENT_DAY_VIEW_OWN: 'client_day_view_own',

    MESSAGES_VIEW: 'messages_view',
    MESSAGES_REPLY: 'messages_reply',

    FACEBOOK_BUSINESS_LINK: 'facebook_business_link',

    REASONS_VIEW: 'reasons_view',
    REASONS_EDIT: 'reasons_edit',

    REPORT_CASH_DRAWER_EDIT: 'report_cash_drawer_edit',
    REPORT_DASHBOARD_VIEW: 'report_dashboard_view',
    REPORT_DASHBOARD_VIEW_OWN: 'report_dashboard_view_own',

    REPORT_BUSINESS_SUMMARY_VIEW: 'report_business_summary_view',
    REPORT_SALES_VIEW: 'report_sales_view',
    REPORT_APPOINTMENT_SOURCES_VIEW: 'report_appointment_sources_view',
    REPORT_STOCK_VALUE_VIEW: 'report_stock_value_view',
    REPORT_PRODUCT_SALES_VIEW: 'report_product_sales_view',
    REPORT_VOUCHER_STATS_VIEW: 'report_voucher_stats_view',
    REPORT_CONCESSION_STATS_VIEW: 'report_concession_stats_view',
    REPORT_CENTRALISED_VOUCHER_VIEW: 'report_centralised_voucher_view',
    REPORT_CENTRALISED_CONCESSION_VIEW: 'report_centralised_concession_view',
    REPORT_LOYALTY_STATS_VIEW: 'report_loyalty_stats_view',
    REPORT_PAYMENTS_RECEIVED_VIEW: 'report_payments_received_view',
    REPORT_PACKAGE_SALES_VIEW: 'report_package_sales_view',
    REPORT_CASHDRAWER_VIEW: 'report_cashdrawer_view',
    REPORT_SUPPLIER_INVOICE_VIEW: 'report_supplier_invoice_view',
    REPORT_DEPOSITS_VIEW: 'report_deposits_view',
    REPORT_DISCOUNTS_VIEW: 'report_discounts_view',
    REPORT_ORDER_VIEW: 'report_order_view',

    REPORT_BENCHMARK_EDIT: 'report_benchmark_edit',

    REPORT_APPROVED_TIMESHEETS_VIEW: 'report_approved_timesheets_view',

    REPORT_TARGETS_VIEW: 'report_targets_view',
    REPORT_TARGETS_VIEW_OWN: 'report_targets_view_own',
    REPORT_TARGETS_EDIT: 'report_targets_edit',

    ROOMS_AND_EQUIPMENT_EDIT: 'rooms_and_equipment_edit',

    SERVICE_DETAILS_VIEW: 'service_details_view',
    SERVICE_DETAILS_EDIT: 'service_details_edit',
    SERVICE_LIST_IMPORT: 'service_list_import',

    CATEGORY_DETAILS_VIEW: 'category_details_view',
    CATEGORY_DETAILS_EDIT: 'category_details_edit',

    STOCK_DETAILS_VIEW: 'stock_details_view',
    STOCK_DETAILS_EDIT: 'stock_details_edit',
    STOCK_LIST_IMPORT: 'stock_list_import',

    SUPPLIER_DETAILS_EDIT: 'supplier_details_edit',
    SUPPLIER_DETAILS_VIEW: 'supplier_details_view',

    STOCKTAKE_DETAILS_VIEW: 'stocktake_details_view',
    STOCKTAKE_DETAILS_EDIT: 'stocktake_details_edit',

    PACKAGE_DETAILS_EDIT: 'package_details_edit',
    PACKAGE_DETAILS_VIEW: 'package_details_view',

    VOUCHER_CANCEL: 'voucher_cancel',
    VOUCHER_CREATE: 'voucher_create',
    VOUCHER_EDIT: 'voucher_edit',
    VOUCHER_SEARCH: 'voucher_search',

    XERO_EDIT: 'xero_edit',

    AUTOMESSAGES_DETAILS_EDIT: 'automessages_details_edit',
    AUTOMESSAGES_DETAILS_VIEW: 'automessages_details_view',

    TIMECLOCK_EDIT: 'timeclock_edit',
    TIMECLOCK_VIEW: 'timeclock_view',

    TIMESHEETS_EDIT: 'timesheets_edit',

    CUSTOM_FORMS_EDIT: 'custom_forms_edit',
    CUSTOM_FORMS_SEND: 'custom_forms_send',
    CUSTOM_FORM_SETTINGS_EDIT: 'custom_form_settings_edit',

    WAITLIST_EDIT: 'waitlist_edit',
    WAITLIST_VIEW: 'waitlist_view',

    SECURITY_LOG_VIEW: 'security_log_view',

    //discovered these were missing while unit testing
    //dumping them at the bottom of the object for now
    TIMESHEETS_VIEW: 'timesheets_view',
    REPORT_DOUBLE_BOOKINGS_VIEW: 'report_double_bookings_view',
    REPORT_CENTRALISED_CONCESSION_LIST_VIEW: 'report_centralised_concession_list_view',
    REPORT_VARIANCE_REPORT_VIEW: 'report_variance_report_view',
    REPORT_STAFF_UTILISATION_VIEW: 'report_staff_utilisation_view',
    REPORT_PAYROLL_VIEW: 'report_payroll_view',
    CUSTOM_ROLES_EDIT: 'custom_roles_edit',
};

// @see KitombaProductConstants.php
var accessConstants = {
    kmail: 'kmail',
    benchmark: 'benchmark',
    onlinebooking: 'onlinebooking',
    reports: 'reports',
    appointments: 'appointments',
    clients: 'clients',
    stock: 'stock',
    services: 'services',
    settings: 'settings',
    messaging: 'messaging',
    packages: 'packages',
    campaigns: 'campaigns',
    targets: 'targets',
    sales: 'sales',
    xero: 'xero',
    timeclock: 'timeclock',
    timesheets: 'timesheets',
    forms: 'forms',
    customroles: 'customroles',
    text_campaigns: 'text_campaigns',
    securitylog: 'securitylog',
    inbox: 'inbox',
};

//see Feature.php
const featureConstants = {
    REASONS: 'Centralised Reasons',
    DATA_GENERATOR: 'Data generator',
    DATA_GENERATOR_CRON: 'Data generator cron',
    RECORDING_APPOINTMENT_BOOK: 'Record appointment book',
    RECORDING_FORM_BUILDER: 'Record form builder',
    WINDCAVE_PAYMENTS: 'Windcave payments',
    KITOMBAPAY_PAYMENTS: 'KitombaPay payments',
    KITOMBAPAY_LIVE: 'KitombaPay live',
    DOWN_TIME_DASHBOARD: 'Down time dashboard',
    PRE_LAG_TIME_SERVICE: 'Pre lag time service',
    PRE_LAG_TIME_GAP: 'Pre lag time gap',
    CACHED_KPI_DATA: 'Cached kpi data generation',
    CACHED_KPI_SQL: 'Cached kpi sql in dashboard',
    DUPLICATE_DB_QUERY_COUNT: 'Use duplicate db to do diff sync count',
    DETAILED_DIFF_HASH_LOGGING: 'Detailed diff hash logging',
    XERO_REFRESH: 'Refresh feature every 60 days',
    VARIANCE_REPORT_DEBUG: 'Variance Report DEBUG',
    APPOINTMENT_SOURCES_GRAPH: 'Enable appt-sources graph',
    TILL_TRANSACTION_STATUS_INVESTIGATION: 'Investigate Till Trans-status',
    LOG_REMOVED_PRICE_OVERRIDES: 'Log removed price overrides',
    LOG_OB_APPT_DELETE: 'Log ob appointment delete',
    SECURITY_LOG: 'Security log tab',
    K1_MESSAGING_EXTRA_LOGGING: 'K1 messaging extra logging',
    SHOW_CLOSED_BRANCH_DATE: 'Show closed branch date',
    YEARLY_SALES_TARGET: 'Yearly sales target for business summary',
    APPT_BOOK_UPDATES: 'Appt book UI refresh and service colors',
    SERVER_STATIC_SINGLEDAYS: 'Server generated static singledays',
    INVENTORY: 'Inventory tab',
    STOCKTAKE: 'Stocktake tab',
    BLOCK_MESSAGE_CLI_LOGGING: 'Block Message cli logging',
    DATA_EXTRACTION: 'Data Extraction',
    NEW_APPOINTMENT_SOURCES: 'Use refactored appointment sources',
    NEW_APPOINTMENT_SOURCES_TESTING: 'Subterfuged new appointment sources',
    ATTRIBUTES: 'Attributes',
    KIT_24711: 'KIT-24711, timesheet breaks',
    VOUCHERS: 'Vouchers',
    KIT_28486: 'KIT-28486 Reauthenticate facebook login',
    KIT_28890_GIVE_TO_CLIENT: 'KIT-28890 disable give to client check',
    KIT_26468_BLOCK: 'block client message updating',
    K1_CONCESSIONS: 'k1 concession',
    REPORT_LOGGING: 'Report logging',
    BALANCE_CASH_DRAWER: 'Balance cash drawer',
    STOCK_ORDERING: 'Stock ordering tab',
    TILL_BILL_TESTING: 'Till Billing Test Facilitator',
};

const kitombaVersionConstants = {
    K1_REFUNDS_KITOMBA_VERSION: '7.550',
    K1_CLIENT_DELETE_KITOMBA_VERSION: '7.570',
    K1_BALANCE_CASH_DRAWER_KITOMBA_VERSION: '7.571',
    K1_STOCK_ORDERING_KITOMBA_VERSION: '7.580',
};

/**
 * @class
 */
function Security() {
    this.check = function (businessToken, permissionConstant) {
        if (!businessToken) {
            return false;
        }

        //check the chain first (this is how the backend works)
        var chainBusiness = business.getFeaturesChain();

        if (chainBusiness && chainBusiness.permissions) {
            var chainCheck = chainBusiness.permissions[permissionConstant];
            if (chainCheck) {
                return true;
            }
        }

        //if the chain didn't pass then try the provided business
        var bus = business.getFeaturesBusiness(businessToken);
        if (bus && bus.permissions) {
            return !!bus.permissions[permissionConstant];
        }

        return false;
    };

    //see if they have permission in any branch or chain
    //we dont need a business token as we are just looking across the chain/boutique we are working with
    this.checkAnyBranch = function (permissionConstant) {
        return _.some(business.getFeatures(), function (item) {
            return item.permissions && item.permissions[permissionConstant];
        });
    };

    this.checkAccess = function (businessToken, accessConstant) {
        return business.getFeaturesBusiness(businessToken).access[accessConstant];
    };

    this.checkCurrentAccess = function (accessConstant) {
        var currentBusiness = $('#selectedBusiness').data('token');

        return this.checkAccess(currentBusiness, accessConstant);
    };

    this.getUserCurrentRole = function () {
        return $('#e-bar-account').data('userrole');
    };

    this.checkCurrentBusiness = function (permissionConstant) {
        var currentBusiness = $('#selectedBusiness').data('token');

        return this.check(currentBusiness, permissionConstant);
    };

    /**
     * Does the business have a feature toggle enabled.
     *
     * Backed by FeatureLibrary::getAllFeatureTogglesMap()
     * Which is a map version of Feature::isOn()
     */
    this.featureIsOn = (featureName) => {
        if (!featuresForcedOff.includes(featureName) && allFeaturesOn) {
            return true;
        }

        const featureToggles = this.getFeatureTogglesEnabledMap();

        if (!featureToggles) {
            // Probably in a test, use turnAllFeaturesOn().
            return false;
        }

        return featureToggles[featureName];
    };

    this.getFeatureTogglesEnabledMap = () => {
        return $('body').data('feature-toggles');
    };

    /**
     * Do all branches support a particular kitomba version.
     *
     * Backed by KitombaVersionHelper::getAllBranchesSupportMap()
     * Which is a map version of allBranchesSupport()
     */
    this.kitombaSupports = (kitombaVersion) => {
        if (allFeaturesOn) {
            return true;
        }

        const kitombaSupports = $('body').data('kitomba-supports');

        if (!kitombaSupports) {
            // Probably in a test, use turnAllFeaturesOn().
            return false;
        }

        return kitombaSupports[kitombaVersion];
    };

    /**
     * Test helper.
     */
    this.turnAllFeaturesOn = (...except) => {
        if (!isTestRunner) {
            throw new Error('turnAllFeaturesOn is for tests only');
        }

        allFeaturesOn = true;
        featuresForcedOff = except;
    };

    this.resetAllFeaturesOn = () => {
        if (!isTestRunner) {
            throw new Error('recentAllFeaturesOn is for tests only');
        }

        allFeaturesOn = false;
        featuresForcedOff = [];
    };
}

//this is a workaround to provide autocompletion

module.exports = Security; //auto complete hack (maybe a way to do this with JSDoc)

module.exports = new Security();
module.exports.permissionConstants = permissionConstants;
module.exports.accessConstants = accessConstants;
module.exports.featureConstants = featureConstants;
module.exports.kitombaVersionConstants = kitombaVersionConstants;
